import { IdGeneratorService } from '../../../services/id-generator.service';
import { AppClientConfigurationService, ServiceResponse } from '@sdbn/common';
import { ResponseStatus } from '@sdbn/common';

import { DialogService } from '@sdbn/common';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Subscription } from 'rxjs';
import { BasicArticle, BasicArticleAttributeValue } from './../basicarticle.model';
import { Component, OnInit, Inject } from '@angular/core';
import { ResponseMessage } from '@sdbn/common';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppFrameContextService } from '@sdbn/common';
import { AccountInfoService } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import {Sort} from '@angular/material/sort';
import { ArticleType } from '../../article-types/article-type.model';
import { Price, PriceContainer, RetailPrice } from '../../erp-common/erp-common.model';
import { ArticleTypeService } from '../../article-types/article-type.service';
import { PriceEditorComponent } from '../../catalog/components/article-editor/price-editor/price-editor.component';


@Component({
    selector: 'app-basicarticle-editor',
    templateUrl: './basicarticle-editor.component.html',
    styleUrls: ['./basicarticle-editor.component.scss'],
    standalone: false
})
export class BasicarticleEditorComponent implements OnInit {

  selected: BasicArticle;
  articleType: ArticleType;

  subscription: Subscription;

  responseMessages = new Array<ResponseMessage>();

  hideVatPrices = true;
  priceScale = 2;

  new = false;

  saveDisabled = false;

  manageBasicArticlePermitted = false;

  formGroup = new FormGroup({ archived: new FormControl(false, []) });

  private priceVatColumn = 'price-vat';
  private priceTaxRateColumn = 'tax-rate';
  retailPricesDisplayedColumns: string[] = ['valid-from', 'valid-until', 'price-net', this.priceTaxRateColumn, this.priceVatColumn, 'reference-date', 'commands'];
  retailPricesDataSource: MatTableDataSource<RetailPrice>;

  constructor(
    private accountInfoService: AccountInfoService,
    private appFrameContextService: AppFrameContextService,
    private _liveAnnouncer: LiveAnnouncer,
    private dialogService: DialogService,
    private articleTypeService: ArticleTypeService,
    private appServerAPI: AppServerAPI,
    private idGenerator: IdGeneratorService,
    public dialogRef: MatDialogRef<BasicarticleEditorComponent>,
    public cps: AppClientConfigurationService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.priceScale = this.cps.getPropertyValue('erp.use-three-digit-prices', 'false') === 'true' ? 3 : 2;
      this.hideVatPrices = this.cps.getPropertyValue('erp.hide-vat-prices', 'false') === 'true';
      this.buildRetailPriceDisplayedColumns();
    }

  private buildRetailPriceDisplayedColumns() {
    if (this.hideVatPrices) {
      this.retailPricesDisplayedColumns.splice(this.retailPricesDisplayedColumns.indexOf(this.priceVatColumn), 1);
      this.retailPricesDisplayedColumns.splice(this.retailPricesDisplayedColumns.indexOf(this.priceTaxRateColumn), 1);
    }
  }

  ngOnInit(): void {
    if (this.checkUserHasPrivilegeManageBasicarticle()) {
      this.manageBasicArticlePermitted = true;
    }

    this.articleType = this.data.articleType.completeArticleType;
    this.selected = this.data.basicArticle;

    console.log('articletype is', this.articleType);
    if (this.selected == null) {
      this.selected = new BasicArticle({ id: this.idGenerator.getNextId(), articleTypeId: this.articleType.id });
      this.selected.priceContainer = new PriceContainer({});
      // check if this is an edit of an existing basicarticle or the creation of a new one
      this.fillBasicArticleWithAttributeDefaultValues(this.selected, this.articleType);
    }

    this.formGroup.controls.archived.setValue(this.selected.archived === true);
    this.updateRetailPriceDataSource();

    this.formGroup.valueChanges.subscribe(formValues => {
      console.log('basicarticle-editor.valueChanges', formValues, this.formGroup);
      this.selected.archived = formValues.archived === true;
    });
    this.formGroup.statusChanges.subscribe(newStatus => {
      console.log('basicarticle-editor.statuschange', newStatus, this.formGroup);
      this.saveDisabled = !this.formGroup.valid;
    });

    // trigger form validation
    this.formGroup.markAllAsTouched();
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    this.sortTableData(sortState);
  }

  onCancel() {
    this.responseMessages.splice(0, this.responseMessages.length);
    this.dialogRef.close();
  }

  onSave() {
    this.responseMessages.splice(0, this.responseMessages.length);
    this.appServerAPI.execute<ServiceResponse>('/client/erp-article/basicarticle/saveBasicArticle', this.selected).subscribe(response => {
      if (response.status === ResponseStatus.SUCCESS) {
        // close dialog
        this.dialogRef.close(new BasicArticle(response));
      } else {

        this.responseMessages.push(...response.responseMessages);
      }
    }, error => {
      console.log('error is', error);
    });

  }


  addRetailPrice() {
    const articleType = this.articleTypeService.getById(this.selected.articleTypeId).completeArticleType;
    this.dialogService.openDefault(PriceEditorComponent, { article: this.selected, articleType: articleType, basic: true, price: new RetailPrice({ id: this.idGenerator.getNextId() }) })
      .afterClosed().subscribe(value => {
        if (value != null) {
          this.selected.priceContainer.retailPrices.push(value as RetailPrice);
          this.updateRetailPriceDataSource();
        }
      });
  }

  editRetailPrice(price: Price) {
    const articleType = this.articleTypeService.getById(this.selected.articleTypeId).completeArticleType;
    this.dialogService.openDefault(PriceEditorComponent, { article: this.selected, price: price, articleType: articleType, basic: true })
      .afterClosed().subscribe(value => {
        this.updateRetailPriceDataSource();
      });
  }

  removeRetailPrice(price: Price) {
    this.dialogService.showConfirm('erp.ui.basicarticle-editor.dialog.remove-retailprice.title', 'erp.ui.basicarticle-editor.dialog.remove-retailprice.message')
      .afterClosed()
      .subscribe(confirmed => {
        if (confirmed) {
          price.deleted = true;
          this.updateRetailPriceDataSource();
        }
      });
  }


  private updateRetailPriceDataSource() {
    this.retailPricesDataSource = new MatTableDataSource(this.selected?.priceContainer?.retailPrices.filter(d => !d.deleted));
  }

  private fillBasicArticleWithAttributeDefaultValues(basicArticle: BasicArticle, articleType: ArticleType) {
    const basicArticleDefinitionAttributes = articleType.basicArticleDefinition.attributes.map(a => a.articleTypeAttribute);
    console.log('fillBasicArticleWithAttributeDefaultValues.basicarticle', basicArticleDefinitionAttributes);

    const attr = [];

      for (const attrib of basicArticleDefinitionAttributes) {
        attr.push(attrib);
        if (basicArticle.attributeValues == null) {
          basicArticle.attributeValues = new Array<BasicArticleAttributeValue>();
        }
        if (attrib.defaultValueId != null) {
          const ba = new BasicArticleAttributeValue({ id: this.idGenerator.getNextId, attributeId: attrib.id, value: attrib.defaultValueId + '' });
          basicArticle.attributeValues.push(ba);
        } else if (attrib.defaultValue != null) {
          const ba = new BasicArticleAttributeValue({ id: this.idGenerator.getNextId, attributeId: attrib.id, value: attrib.defaultValue });
          basicArticle.attributeValues.push(ba);
        }
      }

  }

  private checkUserHasPrivilegeManageBasicarticle(): boolean {
    const yardKey = this.appFrameContextService.tenant.value?.key;
    return this.accountInfoService.checkPrivilegeExistsForYardKey(yardKey, 'erp.manage-basicarticle');
  }

  private sortTableData(sort: Sort) {
    const sortColumn = sort.active;
    const sortOrder = sort.direction === 'desc' ? -1 : 1;
    if (sortColumn === 'valid-from') {
      this.retailPricesDataSource.data  =
        this.retailPricesDataSource.data.sort( (r1,r2) => {
          const r1ValidFrom = r1.validPeriod?.from != null ? r1.validPeriod?.from?.getTime() : 0;
          const r2ValidFrom = r2.validPeriod?.from != null ? r2.validPeriod?.from?.getTime() : 0;
          console.log('sortresult', r1ValidFrom, r2ValidFrom, (r1ValidFrom - r2ValidFrom) * sortOrder);
          return (r1ValidFrom - r2ValidFrom) * sortOrder;
        });
    } else if (sortColumn === 'valid-until') {
      this.retailPricesDataSource.data  =
        this.retailPricesDataSource.data.sort( (r1,r2) => {
          const r1ValidUntil = r1.validPeriod?.until != null ? r1.validPeriod?.until?.getTime() : 0;
          const r2ValidUntil = r2.validPeriod?.until != null ? r2.validPeriod?.until?.getTime() : 0;
          return (r1ValidUntil - r2ValidUntil) * sortOrder;
        });
    } else if (sortColumn === 'price-net') {
      this.retailPricesDataSource.data  =
        this.retailPricesDataSource.data.sort( (r1,r2) => {
          const r1PriceNet = r1.priceNet != null ? r1.priceNet : 0;
          const r2PriceNet = r2.priceNet != null ? r2.priceNet : 0;
          return (r1PriceNet - r2PriceNet) * sortOrder;
        });
    } else if (sortColumn === 'tax-rate') {
      this.retailPricesDataSource.data  =
        this.retailPricesDataSource.data.sort( (r1,r2) => {
          const r1TaxRate = r1.taxRate != null ? r1.taxRate : 0;
          const r2TaxRate = r2.taxRate != null ? r2.taxRate : 0;
          return (r1TaxRate - r2TaxRate) * sortOrder;
        });
    } else if (sortColumn === 'price-vat') {
      this.retailPricesDataSource.data  =
        this.retailPricesDataSource.data.sort( (r1,r2) => {
          const r1PriceVat = r1.priceVat != null ? r1.priceVat : 0;
          const r2PriceVat = r2.priceVat != null ? r2.priceVat : 0;
          return (r1PriceVat - r2PriceVat) * sortOrder;
        });
    } else if (sortColumn === 'reference-date') {
      this.retailPricesDataSource.data  =
        this.retailPricesDataSource.data.sort( (r1,r2) => {
          const r1ReferenceDate = r1.referenceDate != null ? r1.referenceDate : '';
          const r2ReferenceDate = r2.referenceDate != null ? r2.referenceDate : '';
          return r1ReferenceDate.localeCompare(r2ReferenceDate) * sortOrder;
        });
    }

  }
}

